import React from 'react';
import { Box, Col, Row } from '@saucelabs/sl-component-grid';
import { IconManualOutline, IconPlusOutline } from '@saucelabs/ds-icons';
import { IconBulletChecked } from '@saucelabs/sl-component-icons';
import { Button } from '@saucelabs/ds-button';

import { PriceColumn } from '../PriceColumn';
import { SectionTitle } from '../../Layout/SectionTitle';
import { FeatureList } from '../../Plans/FeatureList';

interface LiveTileProps {
  onProductAdd(): void
  price: number
}
const LiveTile: React.FC<LiveTileProps> = ({ onProductAdd, price }) => (
  <Box.Section className="text-high-emphasis">
    <SectionTitle subtitle="Suitable if you or your team are new to cross-browser testing, or are non-technical.">
      <IconManualOutline className="h-3 fill-current text-gray-500" />
      Live Testing
    </SectionTitle>
    <Row between="xs">
      <Col xs>
        <>
          <div className="mt-2 mb-1"><strong>Includes:</strong></div>
          <FeatureList>
            <li>
              <IconBulletChecked />
              Native &amp; Hybrid Mobile App Testing
            </li>
            <li>
              <IconBulletChecked />
              Cross-Browser Testing
            </li>
            <li>
              <IconBulletChecked />
              Unlimited Users
            </li>
            <li>
              <IconBulletChecked />
              Unlimited Testing Minutes
            </li>
          </FeatureList>
        </>
      </Col>
      <PriceColumn
        price={price}
      >
        <Button
          color="primary"
          elementType="button"
          onClick={onProductAdd}
          prefixIcon={<IconPlusOutline />}
          size="md"
          type="button"
          variant="outline"
        >
          Add Plan
        </Button>
      </PriceColumn>
    </Row>
  </Box.Section>
);

export { LiveTile };
